import * as styled from "./StudentList.styled"

function StudentList({students , onSelectStudent, selectedStudent}){
  return (
    <styled.Wrapper>
      <h2>Оберіть учня</h2>
      <ul>
        {students.map(student => (
          <styled.Item key={student._id} onClick={() => onSelectStudent(student)} selectedStudent={selectedStudent?._id === student._id}>
            {student.name} ({student.studentId})
          </styled.Item>
        ))}
      </ul>
    </styled.Wrapper>
  );
};

export default StudentList;
